import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Navbar, Container, NavDropdown, Form, Dropdown } from 'react-bootstrap';
import { HiOutlineShoppingBag, HiUserCircle  } from 'react-icons/hi';
import { useMediaQuery } from 'react-responsive';
import { changeFloatCartState } from '../services/carts/actions';

const Appbar = ({changeFloatCartState, bags}) => {
  const isSmallScreen = useMediaQuery({
    query : '(max-width: 991px)'
  });
  const isBigScreen = useMediaQuery({
    query : '(min-width: 992px)'
  });

  let total = 0;

  bags.forEach(bag => {
    bag.items.forEach(item => {
      total += item.quantity;
    });
  })
  
  return (
    <>
    {isSmallScreen && 
     <Navbar bg="danger" variant='dark' sticky='top' collapseOnSelect expand="lg" >
     <Container>
       <Navbar.Brand href="#home" style={{fontSize: '30px', color: 'white'}}>LOGO</Navbar.Brand>
        <button type="button" className="btn btn-danger cart-icon" onClick={() => changeFloatCartState()}>
          <HiOutlineShoppingBag style={{fontSize: '30px', color: '#eee'}} />
          <span className="bag__quantity">{total}</span>
        </button>
       <Dropdown>
        <Dropdown.Toggle variant="danger" id="dropdown-basic" className="m-2 login-btn">
          <HiUserCircle style={{fontSize: '30px', color: '#eee'}} />
          <Dropdown.Menu>
            <Dropdown.Item href="#">Login</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown.Toggle>
      </Dropdown>
       <Navbar.Toggle aria-controls="responsive-navbar-nav" />
       <Navbar.Collapse id="responsive-navbar-nav" className='justify-content-end'>
         <NavDropdown title="Cloths" id="collasible-nav-dropdown">
           <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 1</NavDropdown.Item>
           <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 2</NavDropdown.Item>
           <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 3</NavDropdown.Item>
         </NavDropdown>
         <NavDropdown title="Watches" id="collasible-nav-dropdown">
           <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 1</NavDropdown.Item>
           <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 2</NavDropdown.Item>
           <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 3</NavDropdown.Item>
         </NavDropdown>
         <NavDropdown title="Home Decor" id="collasible-nav-dropdown">
           <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 1</NavDropdown.Item>
           <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 2</NavDropdown.Item>
           <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 3</NavDropdown.Item>
         </NavDropdown>
         <Form className="my-2">
           <Form.Control type="text" placeholder="Search..." />
         </Form>
       </Navbar.Collapse> 
     </Container>
   </Navbar> 
    }
    {isBigScreen && 
      <Navbar bg="danger" variant='dark' sticky='top' collapseOnSelect expand="lg">
        <Container>
          <Navbar.Brand href="#home" style={{fontSize: '30px', color: 'white'}}>LOGO</Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav" className='justify-content-end'>
            <NavDropdown title="Cloths" id="collasible-nav-dropdown">
              <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 1</NavDropdown.Item>
              <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 2</NavDropdown.Item>
              <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 3</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Watches" id="collasible-nav-dropdown">
              <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 1</NavDropdown.Item>
              <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 2</NavDropdown.Item>
              <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 3</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Home Decor" id="collasible-nav-dropdown">
              <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 1</NavDropdown.Item>
              <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 2</NavDropdown.Item>
              <NavDropdown.Item href="#" onClick={() => {window.alert('Category Link Clicked!')}}>Sub Menu 3</NavDropdown.Item>
            </NavDropdown>
            <Form className="my-2">
              <Form.Control type="text" placeholder="Search..." />
            </Form>
          </Navbar.Collapse> 
        </Container>
        <button type="button" className="btn btn-danger cart-icon" onClick={() => changeFloatCartState()}>
          <HiOutlineShoppingBag style={{fontSize: '30px', color: '#eee'}} />
          <span className="bag__quantity">{total}</span>
        </button>
        <Dropdown>
        <Dropdown.Toggle variant="danger" id="dropdown-basic" className="m-2 login-btn">
          <HiUserCircle style={{fontSize: '30px', color: '#eee'}} />
          <Dropdown.Menu>
            <Dropdown.Item href="#">Login</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown.Toggle>
        </Dropdown>
        
      </Navbar>
    }
    
    </>
  );
};

Appbar.propTypes = {
  changeFloatCartState: PropTypes.func.isRequired
};

const mapsToProps = state => ({
  bags: state.carts.bags
});

export default connect(
  mapsToProps,
  { changeFloatCartState }
)(Appbar);